var _g, _g2, _g3, _g4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnection3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443.57,
    height: 607.17,
    viewBox: "0 0 443.57 607.17",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392.63,606.19h-193.12c-28.09,0-50.94-22.85-50.94-50.94V50.94c0-28.09,22.85-50.94,50.94-50.94h193.12c28.09,0,50.94,22.85,50.94,50.94v504.31c0,28.09-22.85,50.94-50.94,50.94Z",
    fill: "#dadbdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.77,592.4h-193.4c-20.79,0-37.71-16.92-37.71-37.71V50.51c0-20.79,16.92-37.71,37.71-37.71h193.4c20.79,0,37.71,16.92,37.71,37.71v504.18c0,20.79-16.92,37.71-37.71,37.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.42,46.36h-54.69c-7.22,0-13.09-5.87-13.09-13.09s5.87-13.09,13.09-13.09h54.69c7.22,0,13.09,5.87,13.09,13.09s-5.87,13.09-13.09,13.09Z",
    fill: "#dadbdc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.23,200.32h-160.03c-3.17,0-5.75-3.28-5.75-7.3s2.58-7.3,5.75-7.3h160.03c3.17,0,5.75,3.28,5.75,7.3s-2.58,7.3-5.75,7.3Z",
    fill: "#dadbdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.23,232.67h-160.03c-3.17,0-5.75-3.28-5.75-7.3s2.58-7.3,5.75-7.3h160.03c3.17,0,5.75,3.28,5.75,7.3s-2.58,7.3-5.75,7.3Z",
    fill: "#dadbdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.34,265.02h-114.14c-3.17,0-5.75-3.28-5.75-7.3s2.58-7.3,5.75-7.3h114.14c3.17,0,5.75,3.28,5.75,7.3s-2.58,7.3-5.75,7.3Z",
    fill: "#dadbdc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 296.07,
    cy: 386.91,
    r: 68.31,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.9,388.33c3.53,6.91,7.06,13.83,10.59,20.74,1.01,1.99,3.98,1.36,4.57-.6,4.63-15.44,13.23-29.51,24.82-40.7,2.32-2.24-1.22-5.77-3.54-3.54-12.2,11.78-21.23,26.67-26.11,42.91l4.57-.6c-3.53-6.91-7.06-13.83-10.59-20.74-1.46-2.87-5.78-.34-4.32,2.52h.01Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "111.92 304.28 95.36 309.93 95.1 286.02 110.17 285.85 111.92 304.28",
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.04,
    cy: 276.06,
    r: 16.56,
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.57,274.37c-2.77-.05-4.62-2.83-5.73-5.38-1.11-2.54-2.25-5.47-4.82-6.5-2.11-.84-5.75,5.03-7.43,3.5-1.75-1.6-.15-9.94,1.67-11.45s4.33-1.83,6.69-1.97c5.77-.33,11.57.07,17.24,1.19,3.5.69,7.12,1.75,9.67,4.25,3.23,3.17,4.1,8,4.38,12.52.29,4.62.07,9.47-2.13,13.55-2.21,4.07-6.88,7.11-11.41,6.13-.48-2.45-.05-4.97.1-7.47.15-2.49-.07-5.18-1.61-7.15s-4.8-2.72-6.55-.94",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122,279.88c1.64-1.23,3.61-2.27,5.65-2.04,2.21.24,4.09,2.04,4.68,4.18s-.02,4.51-1.36,6.28-3.35,2.95-5.49,3.55c-1.24.35-2.59.5-3.78,0-1.75-.73-2.71-2.94-2.05-4.72",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-334169b2-d322-42da-b25f-a4a8dc7931c2-380",
    d: "m60.38,436.33c-1.04,5.45,1.03,10.4,4.64,11.05,3.6.65,7.37-3.25,8.41-8.7.45-2.17.35-4.42-.29-6.55l12.74-85.41-17.16-3.03-5.65,86.63c-1.38,1.77-2.31,3.83-2.69,6.02h0Z",
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.06,298.96l-11.69.13c-8.25,1.34-10.45,5.78-12.23,13.94-2.73,12.45-6.21,29.04-5.48,29.27,1.17.38,21.17,9.52,31.29,7.26l-1.89-50.6Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.98,
    y: 570.5,
    width: 15.56,
    height: 22.07,
    transform: "translate(-6.49 1.17) rotate(-.64)",
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.06,606.19c-1.64.02-3.09,0-4.19-.09-4.14-.33-8.11-3.34-10.12-5.1-.9-.79-1.2-2.07-.75-3.17h0c.32-.79.98-1.39,1.8-1.64l10.89-3.24,17.55-12.13.2.35c.08.13,1.85,3.24,2.45,5.35.23.8.18,1.47-.15,1.99-.23.36-.55.57-.81.7.32.33,1.33,1,4.43,1.46,4.51.67,5.42-4.02,5.45-4.22l.03-.16.13-.09c2.13-1.41,3.44-2.05,3.9-1.92.29.08.76.22,2.18,12.94.13.4,1.06,3.32.48,6.13-.63,3.06-13.96,2.15-16.62,1.94-.08.01-10.04.83-16.87.9h.02Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.12,
    y: 555,
    width: 15.56,
    height: 22.07,
    transform: "translate(-280.8 171.48) rotate(-32.59)",
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.51,602.52c-1.83.02-3.51-.18-4.71-.38-1.18-.2-2.11-1.12-2.31-2.3h0c-.15-.85.1-1.7.66-2.34l7.52-8.51,8.47-19.58.36.19c.13.07,3.28,1.77,4.91,3.24.62.56.93,1.15.93,1.77,0,.43-.16.78-.32,1.02.45.11,1.66.14,4.53-1.11,4.18-1.82,2.47-6.28,2.39-6.46l-.06-.15.07-.14c1.06-2.32,1.84-3.56,2.29-3.7.29-.08.76-.22,8.7,9.82.32.27,2.66,2.25,3.65,4.94,1.08,2.93-10.7,9.21-13.08,10.44-.07.06-12.38,9.21-17.44,11.83-2.01,1.04-4.4,1.38-6.58,1.4l.02.02Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.79,385.68l-43.56.48-3.5,40.56,18.96,149.54,22.24-.25-9.85-86.38,36.94,77.68,19.61-14.06-28.98-72.58s9.36-63.61,1.28-79.34-13.13-15.67-13.13-15.67v.02Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.48 387.91 71.3 388.68 91.06 299.01 121.21 298.67 140.48 387.91",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-9df903d1-1d84-4918-8ddd-e6aaf747ef0f-381",
    d: "m147.24,435.37c1.16,5.43-.8,10.42-4.39,11.15-3.59.73-7.44-3.08-8.6-8.51-.5-2.16-.45-4.41.14-6.56l-14.64-85.11,17.09-3.41,7.57,86.49c1.42,1.74,2.39,3.78,2.83,5.96h0Z",
    fill: "#f3a3a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.52,298.8l11.69-.13c8.28,1.16,10.57,5.55,12.54,13.67,3,12.39,6.85,28.89,6.13,29.14-1.17.4-20.95,9.98-31.12,7.95l.77-50.63h-.01Z",
    fill: "#6c63ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m215.08,606.19c0,.54-.44.98-.98.98H.98c-.54,0-.98-.44-.98-.98s.44-.98.98-.98h213.12c.54,0,.98.44.98.98h0Z",
    fill: "#3f3d58"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection3);
export default __webpack_public_path__ + "static/media/connection3.394524e906e116b9f53955134d0f48d4.svg";
export { ForwardRef as ReactComponent };